import {
    AMEND_BOOKING_RESERVATION_LOADING_OFF,
    AMEND_BOOKING_RESERVATION_LOADING_ON,
    AMEND_BOOKING_RESERVATION_MESSAGE,
    AMEND_BOOKING_RESERVATION_PHASE,
    AMEND_BOOKING_RESERVATION_PRICES_EMPTY,
    AMEND_BOOKING_RESERVATION_RESET,
    AMEND_BOOKING_RESERVATION_SELECTED_QUOTE,
    CREATE_BOOKING_RESERVATION_TRANSACTION_FAILURE,
    CREATE_BOOKING_RESERVATION_TRANSACTION_SUCCESS,
    CREATE_TRANSACTION_PAYMENT_SUCCESS,
    FETCH_BOOKING_RESERVATIONS,
    FETCH_BOOKING_RESERVATIONS_SUCCESS,
    FETCH_BOOKING_RESERVATION_PRICES,
    FETCH_BOOKING_RESERVATION_PRICES_FAILURE,
    FETCH_BOOKING_RESERVATION_PRICES_SUCCESS,
    FETCH_TRANSACTION_QUOTES_FAILURE,
    FETCH_TRANSACTION_QUOTES_SUCCESS,
} from 'store/actions/types';

const amendInitialState = {
    link: null,
    loading: false,
    message: null,
    phase: 'form',
    prices: {},
    quotes: [],
    selected: null,
    transaction: null,
};

const initialState = {
    amend: amendInitialState,
    data: {},
    loading: false,
};

export const getSelectedQuote = (state) => {
    const {
        quotes,
        selected,
    } = state.bookingReservations.amend;

    const selectedQuote = quotes[selected];

    return selectedQuote ? selectedQuote : null;
};

export default function orders(state = initialState, action) {
    switch (action.type) {
        case FETCH_BOOKING_RESERVATIONS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_BOOKING_RESERVATIONS_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.id]: action.response,
                }),
            });

        case AMEND_BOOKING_RESERVATION_MESSAGE:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    message: action.response,
                }),
            });

        case AMEND_BOOKING_RESERVATION_PHASE:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    phase: action.response,
                }),
            });

        case AMEND_BOOKING_RESERVATION_RESET:
            return Object.assign({}, state, {
                amend: amendInitialState,
            });

        case CREATE_BOOKING_RESERVATION_TRANSACTION_SUCCESS:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    transaction: action.response,
                }),
            });

        case AMEND_BOOKING_RESERVATION_LOADING_OFF:
        case CREATE_BOOKING_RESERVATION_TRANSACTION_FAILURE:
        case FETCH_TRANSACTION_QUOTES_FAILURE:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    loading: false,
                }),
            });

        case AMEND_BOOKING_RESERVATION_LOADING_ON:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    loading: true,
                }),
            });

        case FETCH_TRANSACTION_QUOTES_SUCCESS:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    quotes: action.response,
                }),
            });

        case AMEND_BOOKING_RESERVATION_SELECTED_QUOTE:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    selected: action.selected,
                }),
            });

        case CREATE_TRANSACTION_PAYMENT_SUCCESS:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    link: action.response.payment_url,
                }),
            });

        case FETCH_BOOKING_RESERVATION_PRICES:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    prices: {},
                }),
            });

        case FETCH_BOOKING_RESERVATION_PRICES_FAILURE:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    phase: 'price-check-error',
                    prices: {},
                }),
            });

        case FETCH_BOOKING_RESERVATION_PRICES_SUCCESS:
            const newPrices = {
                currency: action.response.price_currency,
                difference: action.response.price,
                original: action.response.price_original,
                required: action.response.payment_required,
                total: action.response.price_total,
            };

            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    prices: newPrices,
                }),
            });

        case AMEND_BOOKING_RESERVATION_PRICES_EMPTY:
            return Object.assign({}, state, {
                amend: Object.assign({}, state.amend, {
                    message: null,
                    prices: {},
                }),
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/bookingReservationsReducer.js